// Desc: API Base URL import.meta.env.VITE_API_URL
export const API_BASE_URL = 'https://backend.truklex.com/api/'
export const FILE_URL = 'https://backend.truklex.com/api/driver-application/storage/'
export const FILES_URL = 'https://backend.truklex.com/files/'

// Desc: API Endpoints
export const LOGIN_ENDPOINT = `auth/signin`
export const FORGOT_ENDPOINT = `auth/forgot-password`
export const PROFILE_ENDPOINT = `profile`
export const UPDATE_PROFILE_ENDPOINT = `update-profile`
export const CHANGE_PROFILE_ENDPOINT = `change-password`
export const ARTICLE_CATEGORIES_ENDPOINT = `articles/categories`
export const ARTICLE_SOURCES_ENDPOINT = `articles/sources`
export const ARTICLE_AUTHORS_ENDPOINT = `articles/authors`
export const ARTICLES_ENDPOINT = `articles`
export const UPDATE_PREFERENCES_ENDPOINT = `update-preferences`

// driver
export const DRIVER_STORE_ENDPOINT = `driver/store`
export const DRIVER_EDIT_ENDPOINT = `driver/update`
export const GET_DRIVER_MANAGE_ENDPOINT = `driver?document_status=3`
export const GET_DRIVER_ARCHIVE_ENDPOINT = `driver/archive`
export const GET_DRIVER_STATISTICS_ENDPOINT = `driver/statistics`
export const GET_DRIVER_RECRUITMENT_ENDPOINT = `driver?document_status=0,1,2,4`
export const GET_SELECT_DRIVER_ENDPOINT = `select/drivers`
export const VIEW_DRIVER_ENDPOINT = `driver/view`
export const DELETE_DRIVER_ENDPOINT = `driver/delete`
export const RESENT_INVITE_ENDPOINT = `driver/resend-invitation`
export const EDIT_MODE_ENDPOINT = `driver/document-mode`
export const STATUS_ENDPOINT = `driver/respond-application`
export const STATUS2_ENDPOINT = `driver/status`
export const EDIT_APPLICATION_ENDPOINT = `driver/update-application`

// driver application
export const DRIVER_APPLICATION_ENDPOINT = `driver-application`
export const DRIVER_EDIT_APPLICATION_ENDPOINT = `driver-application/edit-request`

// alerts
export const ALERT_STORE_ENDPOINT = `alerts/set`
export const GET_ALERT_ENDPOINT = `alerts/get`
export const ALERT_DISMISS_ENDPOINT = `driver-requests/disable-requests`
export const ALERT_REVISION_ENDPOINT = `driver/respond-application`

// Profile
export const GET_DASHBOARD_ENDPOINT = `user/dashboard`
export const GET_NOTIFICATION_ENDPOINT = `notification`
export const Profile_INFO_ENDPOINT = `me`
export const Profile_UPDATE_ENDPOINT = `me/update`
export const CHANGE_PASSWORD_ENDPOINT = `me/change-password`

// company profile
export const COMPANY_PROFILE_INFO_ENDPOINT = `me/get-company-info`
export const COMPANY_PROFILE_UPDATE_ENDPOINT = `me/update-company-info`

export const ADD_JOB_ENDPOINT = 'driver-jobs/store'
export const EXTRACT_JOB_DOCUMENT_ENDPOINT = 'driver-jobs/extract'
export const GET_JSON_DATA_ENDPOINT = 'driver-jobs/get-json-data'
export const JOB_EDIT_ENDPOINT = 'driver-jobs/update'
export const GET_JOB_ENDPOINT = 'driver-jobs/get'
export const GET_COMPLETED_JOB_ENDPOINT = 'driver-jobs/completed'
export const GET_JOB_STAS_ENDPOINT = 'driver-jobs/statistics'
export const REMOVE_JOB_ENDPOINT = 'driver-jobs/remove'

export const ADD_EXPENCE_ENDPOINT = 'expenses/store'
export const EXPENCE_EDIT_ENDPOINT = 'expenses/update'
export const GET_EXPENCE_ENDPOINT = 'expenses/get'
export const GET_EXPENCE_STATISTIC_ENDPOINT = 'expenses/statistics'
export const REMOVE_EXPENCE_ENDPOINT = 'expenses/remove'

export const ADD_PAYMENT_ENDPOINT = 'payments/store'
export const PAYMENT_EDIT_ENDPOINT = 'payments/update'
export const GET_PAYMENT_ENDPOINT = 'payments/get'
export const GET_PAYMENT_STATISTIC_ENDPOINT = 'payments/statistics'
export const REMOVE_PAYMENT_ENDPOINT = 'payments/remove'
